// extracted by mini-css-extract-plugin
module.exports = {"feedback-reveal":"_36L-lZw4","feedbackReveal":"_36L-lZw4","feedback-reveal__icon-wrapper":"_30WzAjQ0","feedbackReveal__iconWrapper":"_30WzAjQ0"};